// extracted by mini-css-extract-plugin
module.exports = {"emoji":"header_emoji__2lJtI","settings":"header_settings__2bxvv"};